/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Staatsangehoerigkeitfullname2Inputs */



/**

* @param {_Field_Staatsangehoerigkeitfullname2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_staatsangehoerigkeitfullname2 = /** @type {((inputs?: _Field_Staatsangehoerigkeitfullname2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Staatsangehoerigkeitfullname2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Staatsangehörigkeit (Name)")
});
export { _field_staatsangehoerigkeitfullname2 as "_field_staatsangehoerigkeitFullName" }